import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import HttpRoutingService from "../../shared/services/httpRoutingService";
import { API } from "../../shared/apiRoutes";
import { nameExistType, discountTypesForPos, propertyResType, discountValueType, createUpdatePayloadType, updateResType, saveDiscRes, roleArr, customerGroupType, customerType, categoryArr, productArr, brandArr } from "../../components/discounts/automaticDiscount/addEditAutomaticDiscountModule";
import { posDiscount, payloadType, deleteData, bulkDeleteType, discountValues } from "../../components/discounts/automaticDiscount/automaticDiscountModule";
import { ZenToast } from "zen-core-elements";

interface commonType {
    loading: boolean,
    error: string
}

interface discountProp {
    storeId: number;
    data: payloadType | undefined;
}

interface bulkDeleteProp {
    storeId: number;
    data: number[]
}

interface IntialValueProps {
    loading: boolean,
    discountVal: { value: discountValues[], count: number, loading: boolean },
    error: string,
    updateStatus: commonType & { value: deleteData | null },
    bulkDeleteRes: commonType & { value: bulkDeleteType | null },
    checkExistDiscountRes: commonType & { value: nameExistType | null },
    discountTypes: commonType & { value: discountTypesForPos | null },
    propertyCode: commonType & { value: propertyResType | null },
    getOneDiscount: commonType & { value: discountValueType | null },
    updateAutomatic: commonType & { value: updateResType | null },
    createAutomatic: commonType & { value: saveDiscRes | null }
}
const initialState: IntialValueProps = {
    loading: true,
    discountVal: { value: [], count: 0, loading: false },
    error: '',
    updateStatus: { value: null, loading: true, error: "" },
    bulkDeleteRes: { value: null, loading: true, error: "" },
    checkExistDiscountRes: { value: null, loading: true, error: "" },
    discountTypes: { value: null, loading: true, error: "" },
    propertyCode: { value: null, loading: true, error: "" },
    getOneDiscount: { value: null, loading: true, error: "" },
    updateAutomatic: { value: null, loading: true, error: "" },
    createAutomatic: { value: null, loading: true, error: "" },
}

export const getAllPosDiscount = createAsyncThunk("automaticDiscount/getAllPosDiscount", ({ storeId, data }: discountProp) => {
    const url = HttpRoutingService?.replaceUrl(API?.getAllPosDiscount, { storeId: storeId })
    return HttpRoutingService?.getMethod<posDiscount>(url, data)
})

export const updateDiscountStatus = createAsyncThunk("buyXgetYDiscount/updateDiscountStatus", ({ storeId, discountId, data, action }: { storeId: number, discountId: number, data: { isActive?: boolean, isDeleted?: true }, action: string }) => {
    const url = HttpRoutingService?.replaceUrl(API?.updateDiscountStatus, { storeId: storeId, id: discountId })
    const response = action === 'delete' ?
        HttpRoutingService?.deleteMethod<deleteData>(url, data) :
        HttpRoutingService?.putMethod<deleteData>(url, data); return response;
})

export const bulkDeleteDiscount = createAsyncThunk("automaticDiscount/bulkDeleteDiscount", ({ storeId, data }: bulkDeleteProp) => {
    const url = HttpRoutingService.replaceUrl(API.bulkDeleteDiscount, { storeId: storeId })
    return HttpRoutingService.postMethod<bulkDeleteType>(url, { id: data })
})

export const checkExistDiscountName = createAsyncThunk("automaticDiscount/checkExistDiscountName", ({ storeId, data }: { storeId: number, data: { title: string } }) => {
    const url = HttpRoutingService?.replaceUrl(API?.checkExistDiscountName, { storeId: storeId })
    return HttpRoutingService?.getMethod<nameExistType>(url, data, 'v1/')
})

export const getAllDiscountTypesForPos = createAsyncThunk("buyXgetYDiscount/getAllDiscountTypesForPos", ({ storeId }: { storeId: number }) => {
    const url = HttpRoutingService?.replaceUrl(API?.getAllDiscountTypesForPos, { storeId: storeId })
    return HttpRoutingService?.getMethod<discountTypesForPos>(url)
})

export const getPosPropertyCode = createAsyncThunk("automaticDiscount/getPosPropertyCode", ({ storeId, propertyValue }: { storeId: number, propertyValue: string[] }) => {
    const url = HttpRoutingService?.replaceUrl(API?.getPosPropertyCode, { storeId: storeId })
    return HttpRoutingService?.getMethod<propertyResType>(url, { code: JSON.stringify(propertyValue) })
})

export const getCustomerEligibilityTypeData = createAsyncThunk("automaticDiscount/getCustomerEligibilityTypeData", async ({ storeId, url, data, apiVersion = "v2" }: { storeId: number; url: string; data: any, apiVersion: "v1" | "v2" }) => {
    const fullUrl = HttpRoutingService?.replaceUrl(url, { storeId: storeId })
    return HttpRoutingService.getMethod<roleArr & customerGroupType & customerType & categoryArr & productArr & brandArr>(fullUrl, data, `${apiVersion}/`);
});


export const getOneDiscount = createAsyncThunk("automaticDiscount/getOnePosDiscount", ({ storeId, discountId }: { storeId: number, discountId: number }) => {
    const url = HttpRoutingService?.replaceUrl(API?.getOnePosDiscount, { storeId: storeId, discountId: discountId })
    return HttpRoutingService?.getMethod<discountValueType>(url)
})

export const updatedAutomatic = createAsyncThunk("automaticDiscount/updatedDiscount", ({ storeId, id, data }: { storeId: number, id: number, data: createUpdatePayloadType }) => {
    const url = HttpRoutingService?.replaceUrl(API?.updateDiscount, { storeId: storeId, discountId: id })
    return HttpRoutingService?.putMethod<updateResType>(url, data)
})

export const createAutomatic = createAsyncThunk("automaticDiscount/createAutomatic", ({ storeId, data }: { storeId: number, data: createUpdatePayloadType }) => {
    const url = HttpRoutingService?.replaceUrl(API?.saveDiscount, { storeId: storeId })
    return HttpRoutingService?.postMethod<saveDiscRes>(url, data)
})

export const AutomaticDiscountSlice = createSlice({
    name: "automaticDiscount",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getAllPosDiscount?.pending, (state) => {
                state.discountVal.loading = true
            })
            .addCase(getAllPosDiscount?.fulfilled, (state, action) => {
                const offset = action?.meta?.arg?.data?.offset || 0;
                const rows = action?.payload?.discountList?.rows || [];
                if (offset > 0) {
                    state.discountVal.value = [...state.discountVal.value, ...rows];
                }
                else {
                    state.discountVal.value = rows;
                }
                state.discountVal.count = action?.payload?.discountList?.count || 0;
                state.discountVal.loading = false;
            })
            .addCase(getAllPosDiscount?.rejected, (state, action) => {
                state.discountVal.loading = false
                ZenToast({ type: "warning", message: state.error })
            })
            .addCase(updateDiscountStatus?.pending, (state) => {
                state.updateStatus.loading = true
            })
            .addCase(updateDiscountStatus?.fulfilled, (state, action) => {
                state.updateStatus.loading = false
                state.updateStatus.value = action?.payload
            })
            .addCase(updateDiscountStatus?.rejected, (state, action) => {
                state.updateStatus.loading = false
                state.updateStatus.error = action?.error?.message as string
            })
            .addCase(bulkDeleteDiscount?.pending, (state) => {
                state.bulkDeleteRes.loading = true
            })
            .addCase(bulkDeleteDiscount?.fulfilled, (state, action) => {
                state.bulkDeleteRes.loading = false
                state.bulkDeleteRes.value = action?.payload
            })
            .addCase(bulkDeleteDiscount?.rejected, (state, action) => {
                state.bulkDeleteRes.loading = false
                state.bulkDeleteRes.error = action?.error?.message as string
            })
            .addCase(checkExistDiscountName?.pending, (state) => {
                state.checkExistDiscountRes.loading = true
            })
            .addCase(checkExistDiscountName?.fulfilled, (state, action) => {
                state.checkExistDiscountRes.loading = false
                state.checkExistDiscountRes.value = action?.payload
            })
            .addCase(checkExistDiscountName?.rejected, (state, action) => {
                state.checkExistDiscountRes.loading = false
                state.checkExistDiscountRes.error = action?.error?.message as string
            })
            .addCase(getAllDiscountTypesForPos?.pending, (state) => {
                state.discountTypes.loading = true
            })
            .addCase(getAllDiscountTypesForPos?.fulfilled, (state, action) => {
                state.discountTypes.loading = false
                state.discountTypes.value = action?.payload
            })
            .addCase(getAllDiscountTypesForPos?.rejected, (state, action) => {
                state.discountTypes.loading = false
                state.discountTypes.error = action?.error?.message as string
            })
            .addCase(getPosPropertyCode?.pending, (state) => {
                state.propertyCode.loading = true
            })
            .addCase(getPosPropertyCode?.fulfilled, (state, action) => {
                state.propertyCode.loading = false
                state.propertyCode.value = action?.payload
            })
            .addCase(getPosPropertyCode?.rejected, (state, action) => {
                state.propertyCode.loading = false
                state.propertyCode.error = action?.error?.message as string
            })
            .addCase(getOneDiscount?.pending, (state) => {
                state.getOneDiscount.loading = true
            })
            .addCase(getOneDiscount?.fulfilled, (state, action) => {
                state.getOneDiscount.loading = false
                state.getOneDiscount.value = action?.payload
            })
            .addCase(getOneDiscount?.rejected, (state, action) => {
                state.getOneDiscount.loading = false
                state.getOneDiscount.error = action?.error?.message as string
            })
            .addCase(updatedAutomatic?.pending, (state) => {
                state.updateAutomatic.loading = true
            })
            .addCase(updatedAutomatic?.fulfilled, (state, action) => {
                state.updateAutomatic.loading = false
                state.updateAutomatic.value = action?.payload
            })
            .addCase(updatedAutomatic?.rejected, (state, action) => {
                state.updateAutomatic.loading = false
                state.updateAutomatic.error = action?.error?.message as string
            })
            .addCase(createAutomatic?.pending, (state) => {
                state.createAutomatic.loading = true
            })
            .addCase(createAutomatic?.fulfilled, (state, action) => {
                state.createAutomatic.loading = false
                state.createAutomatic.value = action?.payload
            })
            .addCase(createAutomatic?.rejected, (state, action) => {
                state.createAutomatic.loading = false
                state.createAutomatic.error = action?.error?.message as string
            })
    }
})

export default AutomaticDiscountSlice?.reducer